import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import environment from "web/script/modules/environment";
import styles from "./main-navigation-subcategory.css";

function SubCategory(_ref) {
  var title = _ref.title,
      submenu = _ref.submenu,
      show = _ref.show,
      onCategoryClick = _ref.onCategoryClick,
      onClose = _ref.onClose,
      fullRender = _ref.fullRender;
  var hasSubMenus = submenu.menus && submenu.menus.length > 0;
  var hasTrendMenus = submenu.trend_menus && submenu.trend_menus.length > 0;
  var hasLinks = submenu.links && submenu.links.length > 0;

  function renderSubCategory(submenu, type) {
    return submenu[type].map(function (menu) {
      return React.createElement(SubCategory, {
        key: menu.display_name,
        title: menu.display_name,
        submenu: menu,
        fullRender: true
      });
    });
  }

  var iconName = environment.getFeature("rebrand_2020") ? "arrow-icon" : "chevron";
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classnames(styles.subCategoryContainer, _defineProperty({}, styles.show, show))
  }, React.createElement("button", {
    type: "button",
    className: styles.subcategoryTitle,
    onClick: onClose
  }, !fullRender && React.createElement(SVGIcon, {
    className: styles.menuItemBigChevron,
    name: iconName,
    flip: true
  }), title), hasSubMenus && submenu.menus.map(function (menu) {
    return React.createElement("button", {
      key: menu.display_name,
      type: "button",
      className: styles.menuItem,
      onClick: function onClick() {
        onCategoryClick(menu);
      }
    }, menu.display_name, !fullRender && React.createElement(SVGIcon, {
      className: styles.menuItemChevron,
      name: iconName
    }));
  }), hasLinks && submenu.links.map(function (link) {
    return React.createElement("a", {
      key: link.url,
      className: styles.menuItem,
      href: link.url
    }, link.text);
  }), hasTrendMenus && React.createElement(React.Fragment, null, submenu.trend_menus.map(function (trendMenu, index) {
    return React.createElement("button", {
      key: "".concat(submenu.trend_heading, "-").concat(index),
      className: styles.menuItem,
      type: "button",
      onClick: function onClick() {
        onCategoryClick(trendMenu);
      }
    }, trendMenu.display_name, !fullRender && React.createElement(SVGIcon, {
      className: styles.menuItemChevron,
      name: iconName
    }));
  }))), fullRender && hasSubMenus && renderSubCategory(submenu, "menus"), fullRender && hasTrendMenus && renderSubCategory(submenu, "trend_menus"));
}

SubCategory.propTypes = {
  title: PropTypes.string,
  submenu: PropTypes.object,
  isOpen: PropTypes.bool,
  onCategoryClick: PropTypes.func,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  fullRender: PropTypes.bool
};
export default SubCategory;